<template>
  <div class="sku-wrap" v-if="goodsDetail.itemId">
    <div class="goods-info">
      <div class="goods-image">
        <van-image
          v-if="goodsDetail.mainImg"
          :src="goodsDetail.mainImg"
          fit="contain"
          loading-icon="goods"
          error-icon="goods"
          width="100%"
          height="100%"
        />

        <span
          class="rx-shade"
          v-if="goodsDetail.attribute === RxTypeNum.CHUFANGYA0 && rxShadeConfig['shop-compliance-open']"
          :style="rxShadeStyle"
        >
          {{ rxShadeConfig['shop-compliance-content']['tips'] }}
        </span>

        <div class="mask" />
      </div>
      <div class="others">
        <div class="tit">
          <!-- <i v-if="goodsDetail.itemType === 0" class="icon-prescription" /> -->
          {{ goodsDetail.drugName }}
        </div>
        <div class="price-info">
          <div class="rmb">&yen;</div>
          <div class="price-txt">{{ goodsDetail.realPrice | price }}</div>
        </div>
      </div>
      <div class="btn-close" @click="close">
        <van-icon name="cross" class="icon-close" />
        <!-- <icon-font class="icon-close" icon-name="guanbi" /> -->
      </div>
    </div>
    <div class="goods-spec">
      <div class="label">规格</div>
      <div class="spec-group">
        <div class="spec-item" v-if="goodsDetail.spec">{{ goodsDetail.spec }}</div>
        <div class="spec-item" v-else>默认规格</div>
      </div>
    </div>
    <div class="count-select">
      <span class="label">数量</span>
      <van-stepper
        input-width="32px"
        button-size="24px"
        theme="round"
        integer
        :min="1"
        :max="Number(goodsDetail.stockNum) > 999 ? 999 : Number(goodsDetail.stockNum)"
        :value="num"
        async-change
        @change="onStepperChange"
        @overlimit="onOverlimit"
        @blur="onBlur"
      />
    </div>
    <div class="btn-wrap">
      <van-button type="primary" class="btn-submit" :loading="loading" @click="preConfirm">确认</van-button>
    </div>
  </div>
</template>
<script>
import { RxTypeNum } from '@/constant';
import { mapState } from 'vuex';

const MAX_COUNT = 999;
const TOAST_MESSAGE = {
  MIN_COUNT: '您至少需购买一件',
  MAX_COUNT: `单次只能购买${MAX_COUNT}件`,
  stockNum_COUNT: '库存不足，无法购买更多'
};

export default {
  name: 'SkuPopup',
  props: ['visible', 'loading', 'type', 'goodsDetail'],
  data() {
    return {
      num: 1,
      cacheNum: 1,
      RxTypeNum
    };
  },
  computed: {
    ...mapState(['rxShadeConfig']),
    showShade() {
      return this.goodsDetail.isRx === RxTypeNum.CHUFANGYA0 && this.rxShadeConfig['shop-compliance-open'];
    },
    rxShadeStyle() {
      const content = this.rxShadeConfig['shop-compliance-content'];
      return {
        color: `#${content.textColor}`,
        background: `#${content.bgColor}`,
        opacity: content.alpha,
        fontSize: `${content.textSize}px`
      };
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    resetNum() {
      this.num = 1;
    },
    preConfirm() {
      this.$util.submitOnce(this.confirm, this, 1000);
    },
    confirm() {
      // this.close();
      if (this.type === 'cart') {
        this.$emit('addCart', this.num);
      }

      if (this.type === 'buy') {
        this.$emit('submit', this.num);
      }
    },
    onStepperChange(value) {
      if (typeof value !== 'number') {
        this.cacheNum = Number(value);
        return;
      }
      if (value === this.num) return;
      const MAX_NUM = this.goodsDetail.stockNum > 999 ? 999 : this.goodsDetail.stockNum;
      if (value > MAX_NUM) {
        // eslint-disable-next-line no-param-reassign
        value = MAX_NUM;
        const tip = this.goodsDetail.stockNum > 999 ? '购买' : '添加';
        this.$toast(`您最多可${tip}${MAX_NUM}件`);
      }
      this.num = value;
    },
    onOverlimit() {
      if (this.num === 1) {
        this.$toast(TOAST_MESSAGE.MIN_COUNT);
      } else if (this.num === this.goodsDetail.stockNum > 999 ? 999 : this.goodsDetail.stockNum) {
        this.$toast(`您最多可购买${this.goodsDetail.stockNum > 999 ? 999 : this.goodsDetail.stockNum}件`);
      }
    },

    onBlur() {
      if (this.cacheNum < 1) {
        this.$toast(TOAST_MESSAGE.MIN_COUNT);
      }
      const MAX_NUM = this.goodsDetail.stockNum > 999 ? 999 : this.goodsDetail.stockNum;
      if (this.cacheNum > MAX_NUM) {
        this.$toast(`您最多可购买${MAX_NUM}件`);
      }
    }
  }
};
</script>
<style src="./index.less" lang="less" type="text/less" scoped />
